// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__8U00b","footer":"ModalUpdate_footer__eDD-F"};